import { render, staticRenderFns } from "./MyPayment.vue?vue&type=template&id=08ee5698"
import script from "./MyPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./MyPayment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports